module.exports = __webpack_public_path__ + "static/img/6.383652b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/new/6.jpg
// module id = 1bJP
// module chunks = 0